"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThreeBottleSub = exports.getTwoBottleOneTime = exports.getUpsellItem = exports.updateCart = exports.addItem = exports.updateItemQuantity = exports.removeItem = exports.getCartData = exports.isUpsellItem = exports.isSubscriptionItem = exports.showUpsellItem = exports.hasSubscriptionItem = exports.isSubscriptionCartItem = void 0;
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("../components/Cart/CartContext");
var isSubscriptionCartItem = function (item) {
    var _a, _b, _c;
    return (_c = (_b = (_a = item.selling_plan_allocation) === null || _a === void 0 ? void 0 : _a.selling_plan) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.length;
};
exports.isSubscriptionCartItem = isSubscriptionCartItem;
var hasSubscriptionItem = function (cart) {
    if (!cart) {
        return false;
    }
    for (var _i = 0, _a = cart.items; _i < _a.length; _i++) {
        var item = _a[_i];
        if ((0, exports.isSubscriptionCartItem)(item)) {
            return true;
        }
    }
    return false;
};
exports.hasSubscriptionItem = hasSubscriptionItem;
var showUpsellItem = function (cart) {
    if (!cart) {
        return false;
    }
    return cart.total_price < 8000;
};
exports.showUpsellItem = showUpsellItem;
var isSubscriptionItem = function (item) {
    var _a;
    return (_a = item.sellingPlanGroups) === null || _a === void 0 ? void 0 : _a.nodes.length;
};
exports.isSubscriptionItem = isSubscriptionItem;
var isUpsellItem = function (item) {
    return item === null || item === void 0 ? void 0 : item.url.includes('uo1');
};
exports.isUpsellItem = isUpsellItem;
var reverseCartItems = function (cart) {
    cart.items = cart.items.reverse();
    return cart;
};
var getCartData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, cartData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch('/cart.js')];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                cartData = _a.sent();
                return [2 /*return*/, reverseCartItems(cartData)];
            case 3:
                error_1 = _a.sent();
                console.error('Error featching cart data:', error_1);
                return [2 /*return*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getCartData = getCartData;
var removeItem = function (replacedItemId) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response, cartData, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                data = {
                    updates: (_a = {},
                        _a[replacedItemId] = 0,
                        _a),
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                cartData = _b.sent();
                return [2 /*return*/, reverseCartItems(cartData)];
            case 4:
                error_2 = _b.sent();
                console.error('Error removing item from cart:', error_2);
                return [2 /*return*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.removeItem = removeItem;
var updateItemQuantity = function (id, quantity) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response, cartData, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    id: id,
                    quantity: quantity,
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 4];
                return [4 /*yield*/, response.json()];
            case 3:
                cartData = _a.sent();
                return [2 /*return*/, reverseCartItems(cartData)];
            case 4: return [2 /*return*/];
            case 5:
                error_3 = _a.sent();
                console.error('Error updating item quantity in cart:', error_3);
                return [2 /*return*/];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.updateItemQuantity = updateItemQuantity;
var addItem = function (form) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = new FormData(form);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch('/cart/add.js', {
                        method: 'POST',
                        body: data,
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_4 = _a.sent();
                console.error('Error adding item to cart:', error_4);
                return [2 /*return*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.addItem = addItem;
var updateCart = function (event, replacedItem) { return __awaiter(void 0, void 0, void 0, function () {
    var productForm;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                event.preventDefault();
                productForm = event.target;
                if (!productForm) return [3 /*break*/, 4];
                if (!replacedItem) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, exports.removeItem)(replacedItem.variant_id)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, (0, exports.addItem)(productForm)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.updateCart = updateCart;
var getUpsellItem = function (cart) {
    var _a, _b;
    var allProducts = (0, hooks_1.useContext)(CartContext_1.default).allProducts;
    var upsellItem;
    var _loop_1 = function (item) {
        var itemAsProduct = allProducts.find(function (product) { return Number(product.id.split('/')[4]) === item.product_id; });
        // check if upsell product exists for product
        if ((_a = itemAsProduct === null || itemAsProduct === void 0 ? void 0 : itemAsProduct.upsellProduct) === null || _a === void 0 ? void 0 : _a.value) {
            // sub upsells sub
            if ((_b = itemAsProduct.sellingPlanGroups.nodes) === null || _b === void 0 ? void 0 : _b.length) {
                upsellItem = allProducts.find(function (product) {
                    var _a, _b, _c, _d;
                    return ((_a = product.includes) === null || _a === void 0 ? void 0 : _a.value) === ((_c = (_b = itemAsProduct.upsellProduct) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.concat('=1')) &&
                        ((_d = product.sellingPlanGroups.nodes) === null || _d === void 0 ? void 0 : _d.length) &&
                        cart.items.every(function (cartItem) {
                            var _a, _b, _c, _d;
                            var cartItemAsProduct = allProducts.find(function (product) { return Number(product.id.split('/')[4]) === cartItem.product_id; });
                            return (((_b = (_a = cartItemAsProduct === null || cartItemAsProduct === void 0 ? void 0 : cartItemAsProduct.includes) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.split('=')[0]) !==
                                ((_d = (_c = product.includes) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.split('=')[0]));
                        });
                });
                // one-time upsells one-time
            }
            else {
                if (itemAsProduct.handle.includes('uo1')) {
                    return "continue";
                }
                upsellItem = allProducts.find(function (product) {
                    var _a, _b, _c, _d;
                    return ((_a = product.includes) === null || _a === void 0 ? void 0 : _a.value) === ((_c = (_b = itemAsProduct.upsellProduct) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.concat('=1')) &&
                        ((_d = product.sellingPlanGroups.nodes) === null || _d === void 0 ? void 0 : _d.length) === 0 &&
                        product.handle.includes('uo1');
                });
            }
        }
        if (upsellItem) {
            return "break";
        }
    };
    for (var _i = 0, _c = cart.items; _i < _c.length; _i++) {
        var item = _c[_i];
        var state_1 = _loop_1(item);
        if (state_1 === "break")
            break;
    }
    return upsellItem;
};
exports.getUpsellItem = getUpsellItem;
var getTwoBottleOneTime = function (cart) {
    var allProducts = (0, hooks_1.useContext)(CartContext_1.default).allProducts;
    var twoBottleOneTime;
    var _loop_2 = function (item) {
        if (!(0, exports.isSubscriptionCartItem)(item)) {
            var twoBottleOneTimeHandle_1 = item.handle.concat('-o2');
            twoBottleOneTime = allProducts.find(function (product) { return product.handle === twoBottleOneTimeHandle_1; });
            if (twoBottleOneTime) {
                return "break";
            }
        }
    };
    for (var _i = 0, _a = cart.items; _i < _a.length; _i++) {
        var item = _a[_i];
        var state_2 = _loop_2(item);
        if (state_2 === "break")
            break;
    }
    return twoBottleOneTime;
};
exports.getTwoBottleOneTime = getTwoBottleOneTime;
var getThreeBottleSub = function (cart) {
    var allProducts = (0, hooks_1.useContext)(CartContext_1.default).allProducts;
    var threeBottleSub;
    var _loop_3 = function (item) {
        if ((0, exports.isSubscriptionCartItem)(item)) {
            var threeBottleSubHandle_1 = item.handle.concat('-s3');
            threeBottleSub = allProducts.find(function (product) { return product.handle === threeBottleSubHandle_1; });
            if (threeBottleSub) {
                return "break";
            }
        }
    };
    for (var _i = 0, _a = cart.items; _i < _a.length; _i++) {
        var item = _a[_i];
        var state_3 = _loop_3(item);
        if (state_3 === "break")
            break;
    }
    return threeBottleSub;
};
exports.getThreeBottleSub = getThreeBottleSub;
